import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Smartphone, Users, TrendingUp, ChevronRight } from 'lucide-react';

const steps = [
  {
    icon: <BookOpen size={28} />,
    title: 'Belajar',
    description: 'Pelajari dasar-dasar trading dari materi terstruktur dan video interaktif.',
  },
  {
    icon: <Smartphone size={28} />,
    title: 'Latihan Paper Trading',
    description: 'Praktikkan strategi tanpa risiko dengan dana virtual Rp 100jt.',
  },
  {
    icon: <Users size={28} />,
    title: 'Mentoring',
    description: 'Dapatkan bimbingan 1-on-1 dari mentor profesional berpengalaman.',
  },
  {
    icon: <TrendingUp size={28} />,
    title: 'Trading Percaya Diri',
    description: 'Terapkan ilmu dan strategi Anda di pasar nyata dengan keyakinan.',
  },
];

function HowItWorks() {
  return (
    <section className="how-it-works-section">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 60 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <div className="section-label">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0C8F86" strokeWidth="2.5"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12" /></svg>
              Cara Kerja
            </div>
            <h2 style={{ fontSize: 40, fontWeight: 700, color: 'var(--onsurface)', marginBottom: 16, letterSpacing: '-1px' }}>
              Mulai Perjalanan Trading Anda
            </h2>
            <p style={{ fontSize: 16, color: 'var(--text)', maxWidth: 520, margin: '0 auto', lineHeight: 1.7 }}>
              Empat langkah sederhana untuk menjadi trader yang lebih konsisten dan percaya diri.
            </p>
          </motion.div>
        </div>

        <div className="row align-items-center">
          {steps.map((step, i) => (
            <React.Fragment key={step.title}>
              <div className="col-lg-3" style={{ marginBottom: 16 }}>
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.12 }}
                >
                  <div className="how-step-card">
                    <div className="how-step-card__step">Langkah {i + 1}</div>
                    <div className="how-step-card__icon">
                      {step.icon}
                    </div>
                    <h3 className="how-step-card__title">{step.title}</h3>
                    <p className="how-step-card__desc">{step.description}</p>
                  </div>
                </motion.div>
              </div>
              {i < steps.length - 1 && (
                <div className="col-lg-0 d-none d-lg-flex" style={{ width: 'auto', padding: 0 }}>
                  <div className="how-connector">
                    <ChevronRight size={24} />
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
